module.exports = "/_next/static/images/honeybadger-d4654009f8009814b6af6dd9de76e1ee.png";